/** Preserve Classic aliases/encoding while mapping Digital item, spell and Ally artwork. */
export const specialArtworkNames = new Set([
  'MiskatonicStudent', 'MiskatonicAlumnus',
  'Annointed', 'AzureFlame', 'BankLoan', 'BelovedofBast', 'Bless', 'CaptainoftheWhiteShip',
  'Changed', 'ClosingEons', 'CodedMessages', 'CreatureintheMind', 'Curse', 'DarkesBlessing',
  'DeputyofArkham', 'FetishBag', 'FlashForward', 'Gate-Portal', 'Harried', 'InnerBeast',
  'LocalGuide', 'NineLives', 'NodensBlessing', 'OneoftheThousand', 'PrivateInvestigator',
  'Psychic', 'RailPass', 'RareBookCollection', 'Retainer', 'SheldonGangMembership',
  'Shock-WhiteFeather', 'SilverTwilightMembership', 'Tainted', 'TheGreatSeal', 'TheSpores',
  'TheWhiteShip', 'ThirdEye', 'VelmasGratitude', 'Visions', 'Wanted',
  'DiscussionoftheAncientOnes', 'CthulhusFavor',
]);

export const getDigitalItemArtworkPath = (classicPath: string, preview = true): string => {
  if (classicPath.startsWith('/Special/')) {
    let stem = decodeURIComponent(classicPath.slice('/Special/'.length)).replace(/\.(jpg|png)$/, '');
    if (stem.startsWith('BlessingsofNodens:')) stem = 'NodensBlessing';
    if (!specialArtworkNames.has(stem)) return '';
    return `/Special/rework/${preview ? 'small/' : ''}${encodeURIComponent(stem)}.jpg`;
  }
  return classicPath.replace(/^\/(CommonItems|UniqueItems|Spells|Allies)\/([^/]+)$/, `/$1/rework/${preview ? 'small/' : ''}$2`);
};
